import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  width: 100%;
  height:100%;
  flex-direction: column;
  overflow-y:auto;
  overflow-x:hidden;
  padding: 0.5rem;
  gap: 1rem;
  
  .title--{
    font-size: 1.2rem;
    font-weight: bolder;
    gap: 1rem;
  }
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
`